// extracted by mini-css-extract-plugin
export var hiddenPrint = "utilities-module--hidden-print--T9pxj";
export var visuallyHidden = "utilities-module--visually-hidden--Mp6dY";